import { useState } from 'react';
import { Icon } from '../components/Icon.jsx';

/** Woher der aktuelle Wert kommt – kurz für die Anzeige neben dem Titel. */
const QUELLE = {
  verwaltung: ['Eigene Einstellung', 'ok'],
  standard: ['Standard', 'grey'],
  altbestand: ['Bisheriger Wert', 'grey'],
  mandanten: ['Vorgabe ki|partner', 'grey'],
  azure: ['In Azure gesetzt', 'info'],
  'azure-firma': ['In Azure gesetzt', 'info'],
};

export function QuellePill({ quelle, geaendert }) {
  if (geaendert) return <span className="pill warn">Geändert</span>;
  const [text, art] = QUELLE[quelle] ?? ['Nicht gesetzt', 'grey'];
  return <span className={`pill ${art}`}>{text}</span>;
}

/**
 * Eine Einstellung bearbeiten – Eingabe nach Typ aus dem Schema.
 * @param {{ e: object, wert: string|string[]|null|undefined, geaendert: boolean, onChange: (v: unknown) => void }} p
 *   wert undefined = unverändert (Server-Wert anzeigen), null = zurück auf Standard
 */
export function Feld({ e, wert, geaendert, onChange }) {
  const id = `e-${e.name}`;
  const zurueck = wert === null;
  const liste = e.typ === 'liste';
  let aktuell = wert;
  if (zurueck) aktuell = liste ? [] : e.standard ?? '';
  else if (wert === undefined) aktuell = liste ? e.liste : e.wert ?? '';
  return (
    <div className="field" style={{ gap: 8 }}>
      <div className="between" style={{ gap: 8, alignItems: 'flex-start' }}>
        <label htmlFor={id} style={{ fontSize: 16, fontWeight: 800 }}>{e.titel}</label>
        <QuellePill quelle={e.quelle} geaendert={geaendert} />
      </div>
      <span className="sub" style={{ fontSize: 13 }}>{e.beschreibung}</span>
      {e.hinweis && <div className="notice info" role="status"><Icon name="warn" size={18} />{e.hinweis}</div>}
      <Eingabe id={id} e={e} wert={aktuell} onChange={onChange} />
      {(e.quelle === 'verwaltung' && !zurueck) && (
        <button type="button" className="linkbtn" style={{ alignSelf: 'flex-start' }} onClick={() => onChange(null)}>
          Zurück auf {e.standard ? `Standard «${e.standard}»` : 'Standard'}
        </button>
      )}
      {zurueck && <span className="sub" style={{ fontSize: 13 }}>Wird beim Speichern auf den Standard zurückgesetzt.</span>}
    </div>
  );
}

function Eingabe({ id, e, wert, onChange }) {
  if (e.typ === 'liste') return e.name === 'MATERIAL_FAVORITEN' || (wert?.length ?? 0) > 20
    ? <textarea id={id} className="input" rows={6} value={(wert ?? []).join('\n')} onChange={(ev) => onChange(ev.target.value.split('\n'))} placeholder="Ein Eintrag pro Zeile" />
    : <ListenEingabe id={id} werte={wert ?? []} onChange={onChange} />;
  if (e.typ === 'langtext') return <textarea id={id} className="input" rows={5} maxLength={e.max} value={wert} onChange={(ev) => onChange(ev.target.value)} />;
  if (e.typ === 'schalter' || e.typ === 'auswahl') {
    const optionen = e.typ === 'schalter' ? [['1', 'Ein'], ['0', 'Aus']] : e.optionen.map((o) => [o, o]);
    return (
      <div className="segment" role="group" aria-label={e.titel} id={id}>
        {optionen.map(([v, text]) => {
          const an = String(wert || (e.typ === 'schalter' ? '0' : '')) === v;
          return <button key={v} type="button" className={an ? 'on' : ''} aria-pressed={an} onClick={() => onChange(v)}>{text}</button>;
        })}
      </div>
    );
  }
  if (e.typ === 'farbe') return (
    <div className="row">
      <input type="color" aria-label={`${e.titel} wählen`} value={/^#[0-9a-f]{6}$/i.test(wert) ? wert : '#0b6b4e'} onChange={(ev) => onChange(ev.target.value)} style={{ width: 56, height: 56, border: 'none', background: 'none', padding: 0 }} />
      <input id={id} className="input" value={wert} onChange={(ev) => onChange(ev.target.value)} placeholder="#0B6B4E" style={{ flex: 1 }} />
    </div>
  );
  return (
    <input id={id} className="input" value={wert} maxLength={e.max} inputMode={e.typ === 'zahl' ? 'numeric' : undefined}
      onChange={(ev) => onChange(ev.target.value)} placeholder={e.standard ?? ''} />
  );
}

/** Liste als Chips: × entfernt, Feld + «Hinzufügen» ergänzt (auch mit Enter). */
function ListenEingabe({ id, werte, onChange }) {
  const [neu, setNeu] = useState('');
  const hinzu = () => {
    const t = neu.trim();
    if (t && !werte.includes(t)) onChange([...werte, t]);
    setNeu('');
  };
  return (
    <div className="stack" style={{ gap: 8 }}>
      {werte.length > 0 && (
        <div className="wrapchips">
          {werte.map((w) => (
            <button key={w} type="button" className="chip" onClick={() => onChange(werte.filter((x) => x !== w))} aria-label={`${w} entfernen`}>
              {w}<Icon name="x" size={16} stroke={2.4} />
            </button>
          ))}
        </div>
      )}
      <div className="row">
        <input id={id} className="input" value={neu} onChange={(ev) => setNeu(ev.target.value)} placeholder="Neuer Eintrag"
          onKeyDown={(ev) => { if (ev.key === 'Enter') { ev.preventDefault(); hinzu(); } }} style={{ flex: 1 }} />
        <button type="button" className="btn secondary" onClick={hinzu} disabled={!neu.trim()}>Hinzufügen</button>
      </div>
    </div>
  );
}
